// extracted by mini-css-extract-plugin
export default {"qr":"ScanModal_qr__Vp6QR","qrContainer":"ScanModal_qrContainer__hNz-H","qrIconContainer":"ScanModal_qrIconContainer__sXT8r"};